// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aeHG","content":"styles_content__o20K1","row":"styles_row__3Ss7H","footer":"styles_footer__35VNC","phraseLength":"styles_phraseLength__37oEJ"};